<template>
  <div class="right_select flex column relative small_size">
    <div class="select_column flex align_center" @click="toggleChecked()">
      <div class="select_name flex_1">
        {{ selectCheckedList[currentChecked - 1].name }}
      </div>
      <transition name="slide-fade">
        <div class="select_icon">
          <img :src="ImageList.dropdown" alt="" />
        </div>
      </transition>
    </div>
    <transition name="slide-fade">
      <div class="select_option" v-show="option_show">
        <div
          class="option"
          v-for="(list, index) of selectCheckedList"
          :key="index"
        >
          <div @click.stop="chooseInput(list.type)" class="flex align_center">
            <input type="checkbox" :checked="list.checked" />
            <div class="option_name">{{ list.name }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      option_show: false,
      ImageList: {
        dropdown: require("@/assets/icon-font/icon-dropdown.svg")
      }
    };
  },
  computed: {
    selectCheckedList() {
      return [
        {
          name: this.$t("Roots pump motor non-drive end level"),
          type: "1",
          checked: false
        },
        {
          name: this.$t("Roots pump motor drive end level"),
          type: "2",
          checked: false
        },
        {
          name: this.$t("Roots pump drive end - horizontal direction"),
          type: "3",
          checked: false
        },
        {
          name: this.$t("Roots pump non-drive end level"),
          type: "4",
          checked: false
        },
        {
          name: this.$t("Screw pump motor non-driven end level"),
          type: "5",
          checked: false
        },
        {
          name: this.$t("Screw pump motor drive end level"),
          type: "6",
          checked: false
        },
        {
          name: this.$t("Screw pump drive end level"),
          type: "7",
          checked: false
        },
        {
          name: this.$t("Screw pump non-driven end level"),
          type: "8",
          checked: false
        }
      ];
    }
  },
  props: {
    currentChecked: {
      type: String,
      default: "3"
    }
  },
  emits: ["update:currentChecked"],
  watch: {
    option_show(val) {
      let dom = document.getElementsByClassName("select_icon");
      if (val) {
        dom[0].classList.add("rotate");
      } else {
        dom[0].classList.remove("rotate");
      }
    },
    currentChecked: {
      handler(val) {
        this.selectCheckedList.forEach(list => {
          if (list.type == val) {
            list.checked = true;
          } else {
            list.checked = false;
          }
        });
      },
      immediate: true
    }
  },
  mounted() {
    let self = this;
    this.$nextTick(function() {
      document.addEventListener(
        "click",
        e => {
          if (!this.$el.contains(e.target)) {
            this.option_show = false;
          }
        },
        false
      );

      window.addEventListener("keyup", function(e) {
        if (e.keyCode == 27) {
          self.option_show = false;
        }
      });
    });
  },
  beforeUnmount() {
    window.removeEventListener("click", this.toggleChecked);
  },
  methods: {
    chooseInput(type) {
      this.$emit("update:currentChecked", type);
      this.selectCheckedList.forEach(select => {
        if (type == select.type) {
          select.checked = true;
        } else {
          select.checked = false;
        }
      });
      this.toggleChecked();
    },
    toggleChecked() {
      this.option_show = !this.option_show;
    }
  }
};
</script>

<style scoped lang="scss">
.right_select {
  .poninterNone {
    pointer-events: none;
  }
  .select_icon {
    width: 16px;
    background-size: cover;
    background-repeat: no-repeat;
    &.rotate {
      transform: rotate(180deg);
    }
  }
  .select_column {
    border-radius: 10px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    background-color: transparent;
    padding: 10px 20px 10px 0;

    &:hover {
      cursor: pointer;
    }
  }
  .select_option {
    width: 100%;
    background-color: #000;
    border: 4px solid #2c2c2c;
    border-radius: 10px;
    box-sizing: border-box;
    z-index: 8;
    position: absolute;
    top: 100%;
    .option {
      padding: 10px 30px;
      &:nth-of-type(1) {
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
      }
      &:hover {
        cursor: pointer;
        background-color: #062323;
      }
    }
    .option_name {
      margin-left: 10px;
    }
  }
  .select_btn {
    font-weight: 700;
    padding: 8px;
    text-align: center;
    border-top: 2px solid #212121;
    color: #1cc9cb;
    &:hover {
      cursor: pointer;
    }
  }
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: opacity 0.8s;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
}
</style>
